export const COUNTRY_FIELD_NAME = 'country';
export const REGION_FIELD_NAME = 'region';
export const POSTAL_FIELD_NAME = 'postalCode';
export const PROVINCE_FIELD_NAME = 'Province';
export const CITY_MUNICIPALITY_FIELD_NAME = 'City/Municipality';
export const BARANGAY_FIELD_NAME = 'Barangay';
export const STREET_HOUSE_FIELD_NAME = 'House number, Street name';
export const UNIT_FLOOR_FIELD_NAME = 'Unit/Apartment';
